import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const Title = styled(Typography.Header)`
  margin-bottom: 15px;
`;

export const Subtitle = styled(Typography.Caption)`
  margin-top: 5px;
`;

export const Price = styled(Typography.Header)`
  margin-top: 15px;
`;

export const AddBalanceButton = styled(Button)`
  margin-top: 15px;
  margin-bottom: 40px;
`;

export const Card = styled.div`
  padding: 15px;
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.secondary.background};

  &:not(:last-child) {
    margin-bottom: 15px;
  }
`;

export const CardPrice = styled(Typography.Header)`
  margin-top: 10px;
`;
